import { useEffect, useState, useCallback } from "react";
import Modal from "../../Components/Base/Modal";
import {
  campaignsApplicationService,
  jobCampaignsService,
} from "../../Services";
import Lottie from "lottie-react";
import check from "../../assets/Svgs/animationJson/check.json";

export default function InviteCampaigns(props) {
  const { toastList, setToastList } = props;
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [addingToList, setAddingToList] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [campaignData, setCampaignData] = useState(null);
  const [showSuccess, setShowSuccess] = useState(false);
  const [invitedCampaign, setInvitedCampaign] = useState([]);

  let filter = "";
  const page = 1;
  const pageSize = 10;

  const addToast = useCallback(
    (data) => {
      if (typeof setToastList === "function") {
        const currentList = Array.isArray(toastList) ? toastList : [];
        const newToastList = [
          ...currentList,
          { ...data, id: `${Date.now()}-${currentList.length}` },
        ];
        setToastList(newToastList);
      } else {
        console.error(data.error ? "Error:" : "Success:", data.msg);
      }
    },
    [toastList, setToastList]
  );

  const handleInvite = async () => {
    if (!selectedCampaign) {
      addToast({
        error: true,
        msg: "Please select a campaign first",
      });
      return;
    }

    setAddingToList(true);
    try {
      const payload = {
        list_id: props.listId,
      };
      const res = await campaignsApplicationService.PostInvites(
        selectedCampaign.id,
        payload
      );
      if (res.success === true) {
        setShowSuccess(true);
        // addToast({
        //   error: false,
        //   msg: res.message || "Invites sent successfully",
        // });
        setTimeout(() => {
          props.close();
        }, 2000);
      } else {
        addToast({
          error: true,
          msg: res.message || "Failed to send invites",
        });
      }
    } catch (err) {
      const errorMsg =
        err?.message || "An error occurred while sending invites";
      addToast({
        error: true,
        msg: errorMsg,
      });
    } finally {
      setAddingToList(false);
    }
  };

  const fetchInvitedInfluencers = async () => {
    try {
      const res = await campaignsApplicationService.getInvite(
        selectedCampaign.id
      );
      if (res?.success === true) {
        setInvitedCampaign(res?.data);
      }
      // console.log("🚀 ~ fetchInvitedInfluencers ~ res:", res);
    } catch (err) {
      if (err.apiResponseStatus !== 404) {
        console.log(err.message);
      }
    }
  };

  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);
      try {
        const res = await jobCampaignsService.getAllCampaigns({
          page: page,
          pageSize: pageSize,
          sortBy: "desc",
          filter: filter,
        });
        if (res?.data) {
          setCampaignData(res.data.data || res.data || []);
        } else {
          setCampaignData([]);
        }
      } catch (err) {
        if (err.apiResponseStatus !== 404) {
          console.log(err.message);
        }
      } finally {
        setIsLoading(false);
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filteredCampaigns =
    campaignData?.filter((campaign) =>
      campaign?.title?.toLowerCase().includes(searchTerm.toLowerCase())
    ) || [];

  const userDisplayFormat = (count) => {
    if (count >= 1000000000)
      return (count / 1000000000).toFixed(1).replace(/\.0$/, "") + "B";

    if (count >= 1000000)
      return (count / 1000000).toFixed(1).replace(/\.0$/, "") + "M";

    if (count >= 1000)
      return (count / 1000).toFixed(1).replace(/\.0$/, "") + "K";

    return count;
  };

  useEffect(() => {
    if (selectedCampaign) {
      fetchInvitedInfluencers();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCampaign]);

  return (
    <>
      <Modal addClass="modalCamp" close={props.close}>
        <div className="mx-auto bg-white rounded-2xl shadow-xl overflow-hidden relative">
          {showSuccess && (
            <div className="absolute inset-0 bg-white z-50 flex items-center justify-center">
              <Lottie
                animationData={check}
                style={{ width: 150, height: 150 }}
              />
            </div>
          )}
          {/* Header */}
          <div className="p-6 bg-green-100 border-b border-gray-100">
            <div className="flex items-center justify-between">
              <div>
                <h2 className="text-2xl font-bold text-gray-800">
                Select Private Campaign
                </h2>
              </div>
            </div>
          </div>

          {/* Searchable Dropdown */}
          <div className="p-5 bg-gray-50 border-b border-gray-100">
            <div className="relative">
              <div
                className="block w-full pl-10 pr-10 py-3 border border-gray-200 rounded-xl bg-white cursor-pointer focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              >
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg
                    className="h-5 w-5 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                </div>
                <input
                  type="text"
                  className="w-full outline-none bg-transparent"
                  placeholder="Search private campaign..."
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                    setIsDropdownOpen(true);
                  }}
                  onClick={(e) => e.stopPropagation()}
                />
                <div className="absolute inset-y-0 right-0 pr-3 flex items-center gap-2">
                  {selectedCampaign && (
                    <svg
                      className="h-4 w-4 text-gray-400 hover:text-gray-600 cursor-pointer"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedCampaign(null);
                        setSearchTerm("");
                      }}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  )}
                  <svg
                    className={`h-5 w-5 text-gray-400 transition-transform ${
                      isDropdownOpen ? "rotate-180" : ""
                    }`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </div>
              </div>
              {isDropdownOpen && (
                <div
                  className="absolute z-10 w-full mt-2 bg-white border border-gray-200 rounded-xl shadow-lg max-h-60 overflow-y-auto"
                  style={{
                    scrollbarWidth: "thin",
                    scrollbarColor: "#e5e7eb transparent",
                  }}
                >
                  {isLoading ? (
                    <div className="p-4 text-center text-gray-500">
                      Loading...
                    </div>
                  ) : filteredCampaigns.length > 0 ? (
                    filteredCampaigns.map((campaign) => (
                      <div
                        key={campaign.id}
                        className="flex items-center p-3 hover:bg-gray-50 cursor-pointer border-b border-gray-100 last:border-b-0"
                        onClick={() => {
                          setSelectedCampaign(campaign);
                          setSearchTerm(campaign.title);
                          setIsDropdownOpen(false);
                        }}
                      >
                        <div className="ml-3 flex-1">
                          <p className="font-medium text-gray-900">
                            {campaign.title}
                          </p>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="p-4 text-center text-gray-500">
                      No campaigns found
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>

          <div
            className="max-h-96 overflow-y-auto p-5 bg-gray-50"
            style={{
              scrollbarWidth: "thin",
              scrollbarColor: "#e5e7eb transparent",
            }}
          >
            {props.listInfluencer?.length > 0 ? (
              props.listInfluencer?.map((list) => (
                <div
                  key={list.id}
                  className="flex items-center p-4 mb-3 bg-white rounded-xl shadow-sm border border-gray-200 cursor-pointer hover:border-green-400 hover:shadow-md transition-all duration-200 group"
                  onClick={() => {}}
                  style={{
                    opacity: addingToList ? 0.6 : 1,
                    pointerEvents: addingToList ? "none" : "auto",
                  }}
                >
                  <div className="flex-shrink-0 h-12 w-12 rounded-xl overflow-hidden bg-gray-200 border border-gray-300">
                    <img
                      className="h-full w-full object-cover"
                      src={
                        list.profile_img && list.profile_img_url !== ""
                          ? list.profile_img_url
                          : `${process.env.PUBLIC_URL}/images/placeholder/avatar.png`
                      }
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = `${process.env.PUBLIC_URL}/images/placeholder/avatar.png`;
                      }}
                      alt={list.display_name}
                    />
                  </div>
                  <div className="ml-4 flex-1 min-w-0">
                    <h3 className="font-semibold text-gray-900 truncate group-hover:text-green-700 transition-colors">
                      {list.display_name}
                    </h3>
                    <span className="social-icons flex gap-1">
                      {list.social_accounts?.map((account, idx) => (
                        <div
                          key={idx}
                          style={{
                            marginBottom:
                              idx < list.social_accounts.length - 1
                                ? "4px"
                                : "0",
                          }}
                        >
                          {account.platform === "IG" && (
                            <img
                              src="images/instagram.svg"
                              width="20"
                              title="instagram"
                              alt="Instagram"
                            />
                          )}
                          {account.platform === "FB" && (
                            <img
                              src="images/facebook.svg"
                              width="20"
                              title="facebook"
                              alt="Facebook"
                            />
                          )}
                          {account.platform === "YT" && (
                            <img
                              src="images/youtube.svg"
                              width="20"
                              title="youtube"
                              alt="YouTube"
                            />
                          )}
                          {account.platform === "TT" && (
                            <img
                              src="images/tiktok-logo.svg"
                              width="20"
                              title="tiktok"
                              alt="TikTok"
                            />
                          )}
                        </div>
                      )) || "-"}
                      <span className="text-start text-gray-400 ">
                        {userDisplayFormat(
                          list.social_accounts?.[
                            list.social_accounts.length - 1
                          ]?.followers || ""
                        )}
                      </span>
                    </span>
                  </div>
                  {invitedCampaign.some(
                    (invited) => invited.user_id === list.id
                  ) && (
                    <div className="shadow-md ml-2 px-3 py-1 inline-flex items-center gap-2 border-green-50 bg-gray-50 text-gray-500 italic  hover:border-gray-400  hover:from-gray-200 hover:to-gray-300  hover:text-gray-800 hover:shadow-[0_2px_12px_-3px_rgba(0,0,0,0.15)] transition-all duration-200 text-sm font-medium rounded-full backdrop-blur-sm cursor-default">
                      <span className="font-semibold italic">Invited</span>
                    </div>
                  )}
                </div>
              ))
            ) : (
              <div className="text-center py-8 px-4 bg-white rounded-xl border border-dashed border-gray-300">
                <svg
                  className="mx-auto h-12 w-12 text-gray-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                  />
                </svg>
                <h3 className="mt-3 text-lg font-medium text-gray-900">
                  No lists found
                </h3>
              </div>
            )}
          </div>

          {/* Footer with Save Button */}
          <div className="p-5 bg-gray-50 border-t border-gray-200 flex justify-end gap-3">
            <button
              className="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors"
              onClick={handleInvite}
              disabled={!selectedCampaign || addingToList}
            >
              {addingToList ? "Processing..." : "Invite"}
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}
